import { AndGroupEditor } from "./AndGroupEditor";

export class OrGroupEditor extends AndGroupEditor {}
